export enum InputType {
  TEXT = 'text',
  TEXTAREA = 'textarea',
  INFO = 'info',
  NUMBER = 'number',
  SELECT = 'select',
  MULTISELECT = 'multiselect',
  CHECKBOX = 'checkbox',
  SLIDER = 'slider',
  RADIO = 'radio',
  DATE = 'date',
  DATE_TIME = 'date-time',
}

export type QuestionType = `${InputType}`;
